<template>
  <WorkflowReviewCheckmark
    v-if="reviewItem.shouldRender"
    :review="reviewItem.review"
    :reviews="reviewItem.reviews"
    hide-tooltip="true"
    icon-size="sf-font-s"
  />
</template>
<script setup lang="ts">
import type { WorkflowReviewStatusData } from '@app/shared/types/sf-data'

import isEqual from 'lodash/isEqual'
import { storeToRefs } from 'pinia'
import { ref, watch } from 'vue'

const emit = defineEmits<{ 'review-status-updated': [] }>()

import WorkflowReviewCheckmark from '@app/application/workflows/sections/workflow-review-checkmark.vue'

import { useWorkflowOverview } from '@app/application/workflow-overview-navigation/store/overview'

type LocalReviewItem = {
  reviews: WorkflowReviewStatusData['reviews']
  review: WorkflowReviewStatusData['review']
  shouldRender: boolean
}

interface Props {
  itemId: number
}

const props = withDefaults(defineProps<Props>(), {
  itemId: 0,
})

const reviewItem = ref<LocalReviewItem>({
  reviews: [],
  review: null,
  shouldRender: false,
})

const overviewStore = useWorkflowOverview()

const { itemAndGroupReviewsById } = storeToRefs(overviewStore)

watch(
  itemAndGroupReviewsById,
  (newValue, oldValue) => {
    if (
      newValue[props.itemId]?.review !== oldValue?.[props.itemId]?.review ||
      !isEqual(
        newValue[props.itemId]?.reviews,
        oldValue?.[props.itemId]?.reviews
      )
    ) {
      reviewItem.value = {
        reviews: newValue[props.itemId]?.reviews,
        review: newValue[props.itemId]?.review,
        shouldRender: !!newValue[props.itemId],
      }

      const hasReviews = (newValue?.[props.itemId]?.reviews || []).length > 0
      const hadReviews = (oldValue?.[props.itemId]?.reviews || []).length > 0
      const isInitializing = oldValue === undefined

      if (!isInitializing && hadReviews !== hasReviews) {
        emit('review-status-updated')
      }
    }
  },
  {
    immediate: true,
  }
)
</script>
